
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      input: {
        id: this.$route.params.show,
        page: 1,
      },
      modal: {
        comment_limit: 6,
        active: false,
      },
    }
  },

  computed: {
    ...mapState('product/detail', ['comments', 'comment_error_message']),

    device() {
      return this.$device
    },

    product_comments: {
      get() {
        return this.comments.data ? this.comments.data : []
      },
      set() {
        return this.comments.data ? this.comments.data : []
      },
    },

    filtered_comments: {
      get() {
        return !this.modal.active &&
          this.$device.isMobile &&
          this.product_comments.length > this.modal.comment_limit
          ? this.product_comments.slice(0, this.modal.comment_limit)
          : this.product_comments
      },
      set() {
        !this.modal.active &&
        this.$device.isMobile &&
        this.product_comments.length > this.modal.comment_limit
          ? this.product_comments.slice(0, this.modal.comment_limit)
          : this.product_comments
      },
    },
  },

  watch: {
    'input.page': {
      deep: true,
      handler(val, old) {
        if (val != old) {
          this.getComments(this.input)
        }
        if (val != this.comments.current_page) {
          if (this.$device.isMobile) {
            this.$refs.commentsModal.scrollTo(0, 0)
          } else {
            this.scrollToComment()
          }
        }
      },
    },
  },

  async mounted() {
    this.getComments(this.input)
  },

  methods: {
    ...mapActions({
      getComments: 'product/detail/getComments',
    }),
    /**
     * @description: comment scroll to view.
     * @param {*}
     * @return {*}
     */
    scrollToComment() {
      const commentRef = this.$refs.comment
      if (!commentRef) {
        return
      }

      const top = commentRef.getBoundingClientRect().top + window.scrollY - 260
      window.scrollTo(0, top)
    },
    showComment() {
      this.modal.active = true
      this.$nuxt.$emit('ja-backdrop', true)
    },
    closeComment() {
      this.modal.active = false
      this.$nuxt.$emit('ja-backdrop', false)

      //reset comment page
      this.input.page = 1
      this.scrollToComment()
    },
  },
}
